<script lang="typescript">
    import { fly } from "svelte/transition";
    export let transitionParams: { y: number; duration: number; delay?: number } = {
        y: 350,
        duration: 600,
    };
    export let onClick;
    export let isSelected: boolean = false;
    export let classes: string = "";
    $: classModifier = isSelected ? "selected" : "";
</script>

<button
    type="button"
    class="prescription-button {classes} {classModifier}"
    on:click={onClick}
    in:fly={transitionParams}
>
    <slot />
</button>

<style>
    button {
        @apply bg-primary-light border-0 text-white border-white px-2 py-2 w-48 h-16;
        @apply flex items-center justify-center text-xl rounded-md;
    }

    .selected {
        @apply bg-white text-primary shadow-inner;
    }

    .gap {
        @apply mr-32;
    }
</style>
